import type { Handler } from './handler';
import type { ApiFetchRoulettePrizeHistoryPort } from './ports/api-fetch-roulette-prize-history.port';
import type { PrizeHistoryPage } from '~/types/roulette';
import { resolveAdapter } from '~/adapters/registry';

export const fetchRoulettePrizeHistoryHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchRoulettePrizeHistory: resolveAdapter(
      'apiFetchRoulettePrizeHistory',
    ),
  },
) => {
  return await ports.apiFetchRoulettePrizeHistory.handle(params.page);
};

type Params = { page: number };

type Ports = { apiFetchRoulettePrizeHistory: ApiFetchRoulettePrizeHistoryPort };

type Result = Promise<PrizeHistoryPage>;
